"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const BreadcrumbQuery = (0, graphql_tag_1.default) `
  query breadcrumbQuery($categoryId: String!, $subCategoryId: String) {
    categoryContent(categoryId: $categoryId, subcategoryId: $subCategoryId) {
      breadcrumb {
        label
        categoryId
        subcategoryId
        meta {
          description
          canonical
          title
        }
      }
    }
  }
`;
exports.default = BreadcrumbQuery;
